// TODO: 参考元のコード markdown-it-special-terms のライセンスについて要確認 (NFR-770)
'use strict';

export default function anaume_plugin(md, options) {

   // 穴埋めのシークエンスを ruler に追加
   md.inline.ruler.after('emphasis', 'anaume', function anaume(state, silent) {

      // 0x5B = `[`
      const openBrace = 0x5B;
      // 0x5D = `]`
      const closeBrace = 0x5D;

      var originalPosition = state.pos;
      var originalMax = state.posMax;

      var start = state.pos;
      // `[` で始まっているかどうか
      if (state.src.charCodeAt(start) !== openBrace) {
         return false;
      }

      // `[` の次の文字
      var secondCode = state.src.charCodeAt(start + 1);
      // `[` の次の次の文字
      var thirdCode = state.src.charCodeAt(start + 2);

      var level = 0;
      var indexOfClosingBrace = 0;
      var content = null;

      // level = 1 (`[]`が一つのみ)についてはリンクや画像の書き方とバッティングするため処理しない
      // ( [リンク](example.com) のような記述を拾って変換してしまう )

      // level = 2 `[[` で始まっている
      if (secondCode === openBrace) {
         level = 2;
         indexOfClosingBrace = state.src.indexOf("]]", start);
      }
      // level = 3 `[[[` で始まっている
      if (thirdCode === openBrace && secondCode === openBrace) {
         level = 3;
         indexOfClosingBrace = state.src.indexOf("]]]", start);
      }

      // get the content which is from the last openbrace to the last index of closing
      if (indexOfClosingBrace > 0) {

         content = state.src.slice(start + level, indexOfClosingBrace);

         switch (level) {
            case 2:
               var token = state.push('fill_area_open', '', 1);
               token.markup = '[[';

               token = state.push('text', '', 0);
               token.content = content;

               token = state.push('fill_area_close', '', -1);
               token.markup = ']]';
               break;
            case 3:
               var token = state.push('fill_area_long_open', '', 1);
               token.markup = '[[[';

               token = state.push('text', '', 0);
               token.content = content;

               token = state.push('fill_area_long_close', '', -1);
               token.markup = ']]]';
               break;
            default:
               break;
         }

         state.pos = indexOfClosingBrace + level;
         return true;
      }

      return false;
   });

   options = options || {};

   var open_fill_area = options.open_fill_area || "<span class='fill-area'>";
   var close_fill_area = options.close_fill_area || "</span>";

   var open_fill_area_long = options.open_fill_area_long || "<span class='fill-area-long'>";
   var close_fill_area_long = options.close_fill_area_long || "</span>";

   md.renderer.rules["fill_area_open"] = function(tokens, idx, options, env, renderer) {
      return open_fill_area;
   }

   md.renderer.rules["fill_area_long_open"] = function(tokens, idx, options, env, renderer) {
      return open_fill_area_long;
   }

   md.renderer.rules["fill_area_close"] = function(tokens, idx, options, env, renderer) {
      return close_fill_area;
   }

   md.renderer.rules["fill_area_long_close"] = function(tokens, idx, options, env, renderer) {
      return close_fill_area_long;
   }

};
